export function calculatePercentage(num: number, total: number) {
    return ((num/total)*100).toFixed(2);
}
